
import { getAllBlogs } from '~/graphql/queries.graphql'

export default {
  props: {
    page: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    blogs: [],
  }),

  async fetch() {
    const { entries } = await this.$graphql.cms.request(getAllBlogs)

    this.blogs = entries.data
  },
}
